import { registerFeatureWithDescription } from "lib/features"

// Gates the multi-step "create share link" wizard. Off by default so everyone keeps the original
// single-dialog create/settings flow; enable per-client to opt into the wizard while it beds in.
export const FEATURE_FLAG_SHARE_LINK_WIZARD = registerFeatureWithDescription({
    numericalId: 26,
    id: "share-link-wizard",
    name: "Share-Link Create Wizard",
    internalUseOnly: true,
    descriptionLines: [
        "Replaces the single-dialog share-link create/settings screen with a guided multi-step wizard.",
        "When off, the classic single-dialog flow is used.",
    ],
})
